(function () {
  'use strict';

  var RESTRICTED_TAG = 'csak-edesmackoba-rendelheto';
  var GASTRO_LABEL_TEXT = 'Vitéz Gastro bemutató terem';
  var DISABLED_CLASS = 'gastro-pickup-disabled';
  var TAG_CACHE_KEY = 'vk_gpl_tag_cache';
  var LAST_RESULT_KEY = 'vk_gpl_last_restricted';

  var productTagCache = {};

  // Fetching the product tags (/products/{handle}.js) is the main slow factor. Once
  // fetched for a product, we also store it in localStorage, so a subsequent page
  // load doesn't need to hit the network again for the same product.
  function readTagCache() {
    try {
      return JSON.parse(localStorage.getItem(TAG_CACHE_KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  function writeTagCache(handle, tags) {
    try {
      var cache = readTagCache();
      cache[handle] = tags;
      localStorage.setItem(TAG_CACHE_KEY, JSON.stringify(cache));
    } catch (e) {
      // localStorage not available (e.g. private mode) -> silently skip
    }
  }

  function readLastRestricted() {
    try {
      return localStorage.getItem(LAST_RESULT_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function writeLastRestricted(restricted) {
    try {
      localStorage.setItem(LAST_RESULT_KEY, restricted ? '1' : '0');
    } catch (e) {
      // no-op
    }
  }

  function getHandleFromUrl(url) {
    if (!url) return null;
    try {
      var path = url.split('?')[0];
      var parts = path.split('/').filter(Boolean);
      var idx = parts.indexOf('products');
      return idx > -1 && parts[idx + 1] ? parts[idx + 1] : null;
    } catch (e) {
      return null;
    }
  }

  function getProductTags(handle) {
    if (!handle) return Promise.resolve([]);
    if (productTagCache.hasOwnProperty(handle)) {
      return Promise.resolve(productTagCache[handle]);
    }
    var persisted = readTagCache();
    if (persisted.hasOwnProperty(handle)) {
      productTagCache[handle] = persisted[handle];
      return Promise.resolve(persisted[handle]);
    }
    return fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('product fetch failed: ' + handle);
        return res.json();
      })
      .then(function (product) {
        var tags = product.tags || [];
        productTagCache[handle] = tags;
        writeTagCache(handle, tags);
        return tags;
      })
      .catch(function (err) {
        console.warn('[gastro-pickup-lock] Nem sikerült lekérni a termék címkéit:', handle, err);
        return [];
      });
  }

  function cartHasRestrictedProduct() {
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var handles = [];
        (cart.items || []).forEach(function (item) {
          var handle = getHandleFromUrl(item.url);
          if (handle && handles.indexOf(handle) === -1) handles.push(handle);
        });
        return Promise.all(handles.map(getProductTags));
      })
      .then(function (tagLists) {
        return tagLists.some(function (tags) {
          return tags.indexOf(RESTRICTED_TAG) !== -1;
        });
      })
      .catch(function (err) {
        console.warn('[gastro-pickup-lock] Nem sikerült lekérni a kosarat:', err);
        return false;
      });
  }

  // The widget is sometimes in the DOM in multiple instances at once (e.g. a
  // hidden/inactive earlier render + the visible current one), so EVERY matching
  // row needs to be found and hidden, not just the first.
  function findGastroRows() {
    var headings = document.querySelectorAll('.pickup-location-heading');
    var rows = [];
    for (var i = 0; i < headings.length; i++) {
      if (headings[i].textContent.trim() === GASTRO_LABEL_TEXT) {
        var row = headings[i].closest('.pickup-location');
        if (row) rows.push(row);
      }
    }
    return rows;
  }

  function setRowDisabled(row, disabled) {
    if (!row) return;
    var input = row.querySelector('input[type="radio"]');
    row.classList.toggle(DISABLED_CLASS, disabled);
    if (input) {
      input.disabled = disabled;
      if (disabled && input.checked) {
        input.checked = false;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  var applyInProgress = false;
  var applyQueued = false;

  function applyGastroLock() {
    if (applyInProgress) {
      applyQueued = true;
      return;
    }
    var rows = findGastroRows();
    if (!rows.length) return; // the widget isn't (or isn't yet) in the DOM

    // Apply the last known decision immediately, without waiting on the network,
    // so the Gastro pickup point doesn't flash while the fresh check runs.
    var lastKnown = readLastRestricted();
    rows.forEach(function (row) {
      setRowDisabled(row, lastKnown);
    });

    applyInProgress = true;
    cartHasRestrictedProduct()
      .then(function (restricted) {
        writeLastRestricted(restricted);
        rows.forEach(function (row) {
          setRowDisabled(row, restricted);
        });
      })
      .finally(function () {
        applyInProgress = false;
        if (applyQueued) {
          applyQueued = false;
          applyGastroLock();
        }
      });
  }

  // Style for fully hiding it
  var style = document.createElement('style');
  style.textContent =
    '.pickup-location.' + DISABLED_CLASS + ' {' +
    '  display: none !important;' +
    '}';
  document.head.appendChild(style);

  // Re-check when the widget re-renders (e.g. when the shipping method changes)
  var debounceTimer = null;
  var observer = new MutationObserver(function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(applyGastroLock, 150);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Re-check after cart operations (add/change/update/clear)
  var originalFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    var result = originalFetch.apply(this, args);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      result.then(function () { setTimeout(applyGastroLock, 200); }).catch(function () {});
    }
    return result;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyGastroLock);
  } else {
    applyGastroLock();
  }

  // Manual re-check from other scripts, if needed:
  window.gastroPickupLockRefresh = applyGastroLock;
})();
